import { render, staticRenderFns } from "./table.vue?vue&type=template&id=333a1382"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('333a1382')) {
      api.createRecord('333a1382', component.options)
    } else {
      api.reload('333a1382', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=333a1382", function () {
      api.rerender('333a1382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/forwarding-address/table/table.vue"
export default component.exports